import { render, staticRenderFns } from "./IngredientCard.vue?vue&type=template&id=ccaf87ce&scoped=true&"
import script from "./IngredientCard.vue?vue&type=script&lang=js&"
export * from "./IngredientCard.vue?vue&type=script&lang=js&"
import style0 from "./IngredientCard.vue?vue&type=style&index=0&id=ccaf87ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf87ce",
  null
  
)

export default component.exports